(function () {
  const renderBullets = function (swiper, current, total) {
    let out = "";
    for (let i = 1; i < total + 1; i++) {
      const activeClass = i === current ? " swiper-pagination-bullet-active" : "";
      out += `<span class="swiper-pagination-bullet${activeClass}" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`;
    }
    return out;
  };

  const initSlider = (root) => {
    const container = root.querySelector("[data-treatments-swiper]");
    if (!container || typeof Swiper === "undefined") return;

    if (container.swiperInstance) {
      container.swiperInstance.destroy(true, true);
      container.swiperInstance = null;
    }

    const slides = container.querySelectorAll(".swiper-slide");
    if (slides.length === 0) return;

    const columns = parseInt(root.dataset.columns, 10) || 4;
    const gap = parseInt(getComputedStyle(root).getPropertyValue("--ts-gap"), 10) || 24;
    const autoplay = root.dataset.autoplay === "true";
    const delay = parseInt(root.dataset.delay, 10) || 4000;

    // Looping needs more slides than are visible, otherwise Swiper duplicates
    // into a broken track.
    const loop = root.dataset.loop === "true" && slides.length > columns;

    const options = {
      loop: loop,
      speed: 600,
      watchOverflow: true,
      slidesPerView: 1.15,
      spaceBetween: gap,
      breakpoints: {
        600: {
          slidesPerView: Math.min(2, columns),
          slidesPerGroup: 1,
          spaceBetween: gap,
        },
        990: {
          slidesPerView: Math.min(3, columns),
          slidesPerGroup: 1,
          spaceBetween: gap,
        },
        1200: {
          slidesPerView: columns,
          slidesPerGroup: 1,
          spaceBetween: gap,
        },
      },
    };

    const prev = root.querySelector("[data-treatments-prev]");
    const next = root.querySelector("[data-treatments-next]");
    if (prev && next) {
      options.navigation = {
        prevEl: prev,
        nextEl: next,
        disabledClass: "swiper-button-disabled",
      };
    }

    const pagination = root.querySelector("[data-treatments-pagination]");
    if (pagination) {
      options.pagination = {
        el: pagination,
        clickable: true,
        type: "custom",
        renderCustom: renderBullets,
      };
    }

    if (autoplay) {
      options.autoplay = {
        delay: delay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    container.swiperInstance = new Swiper(container, options);
  };

  const initSection = (section) => {
    if (!section) return;
    const roots = section.querySelectorAll
      ? section.querySelectorAll("[data-treatments-slider]")
      : [];
    roots.forEach((root) => initSlider(root));
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", (event) => {
    initSection(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const container = event.target.querySelector("[data-treatments-swiper]");
    if (container && container.swiperInstance) {
      container.swiperInstance.destroy(true, true);
      container.swiperInstance = null;
    }
  });

  document.addEventListener("shopify:block:select", (event) => {
    const root = event.target.closest("[data-treatments-slider]");
    if (!root) return;
    const container = root.querySelector("[data-treatments-swiper]");
    if (!container || !container.swiperInstance) return;
    const index = Array.prototype.indexOf.call(
      container.querySelectorAll(".swiper-slide"),
      event.target
    );
    if (index > -1) {
      container.swiperInstance.slideTo(index);
    }
  });
})();